import { Typography } from "@shared/ui.primitives";
import React from "react";

import { verticalProductCardProductName } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "productName">;
};

export const VerticalProductCardProductName: React.FC<Props> = ({
  product
}) => {
  if (!product.productName) return null;
  return (
    <div className={verticalProductCardProductName}>
      <Typography variant="product-sm" colour="primary-medium">
        {product.productName}
      </Typography>
    </div>
  );
};
